import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import dictEn from './locales/en'
import dictJa from './locales/ja'

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // the translations
    // (tip move them in a JSON file and import them,
    // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
    resources: {
      en: {
        translation: dictEn,
      },
      ja: {
        translation: dictJa,
      },
    },
    fallbackLng: 'ja', // Changed default fallback to 'ja' as per the comment in useLanguage hook
    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
    // メモリ効率を改善
    cleanCode: true,
    debug: false,
    // キャッシュサイズを制限
    cache: {
      enabled: true,
      expirationTime: 60 * 60 * 1000, // 1時間
    },
    // 不要な機能を無効化
    saveMissing: false,
    updateMissing: false,
    detection: {
      // Configure language detection to be less aggressive
      // User's preferred language will override this via useLanguage hook
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  })

export default i18n
